export const IContinueUseCaseType = Symbol('IContinueUseCase');
